export class Input {
  held = false;
  private jumpQueued = false;
  private el: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
    this.onDown = this.onDown.bind(this);
    this.onUp = this.onUp.bind(this);
    this.onKey = this.onKey.bind(this);
    el.addEventListener("pointerdown", this.onDown);
    window.addEventListener("pointerup", this.onUp);
    window.addEventListener("pointercancel", this.onUp);
    window.addEventListener("keydown", this.onKey);
    window.addEventListener("keyup", this.onKey);
  }

  consumeJump(): boolean {
    if (!this.jumpQueued) return false;
    this.jumpQueued = false;
    return true;
  }

  clearJump(): void {
    this.jumpQueued = false;
  }

  dispose(): void {
    this.el.removeEventListener("pointerdown", this.onDown);
    window.removeEventListener("pointerup", this.onUp);
    window.removeEventListener("pointercancel", this.onUp);
    window.removeEventListener("keydown", this.onKey);
    window.removeEventListener("keyup", this.onKey);
  }

  private onDown(e: PointerEvent): void {
    if (e.button !== 0 && e.pointerType === "mouse") return;
    const target = e.target as HTMLElement | null;
    if (target?.closest("button, a, input, textarea, label, select, form")) return;
    e.preventDefault();
    this.held = true;
    this.jumpQueued = true;
  }

  private onUp(): void {
    this.held = false;
  }

  private onKey(e: KeyboardEvent): void {
    if (e.code !== "Space" && e.code !== "ArrowUp") return;
    if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;
    e.preventDefault();
    if (e.type === "keydown" && !e.repeat) {
      this.held = true;
      this.jumpQueued = true;
    }
    if (e.type === "keyup") this.held = false;
  }
}
